import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { MentorshipProgramGoalItemsSchema } from 'redux/schemas/api/mentoring-program-goal-items';
import {
  createMentorshipProgramGoalItem,
  deleteMentorshipProgramGoalItem,
  getMentorshipProgramGoalItems,
  MentoringProgramGoalResponse,
  setMentorshipProgramGoalsTotalCount,
  updateMentorshipProgramGoalItem,
} from 'redux/actions/mentoring-program-goal-items';
import { RootState } from 'redux/schemas';
import { initialRootState } from '.';

const setProgramGoalItemActionHandler = (state: RootState, action: ReturnType<typeof getMentorshipProgramGoalItems.fulfilled>) => {
  const {
    meta: {
      arg: { enrollmentId },
    },
  } = action;
  const { entities: { mentorshipProgramGoalItems } } = normalize(action.payload, MentorshipProgramGoalItemsSchema);
  state.models.mentorshipProgramGoalItems[enrollmentId] = {
    ...state.models.mentorshipProgramGoalItems[enrollmentId],
    goals: {
      ...state.models.mentorshipProgramGoalItems[enrollmentId]?.goals,
      ...mentorshipProgramGoalItems,
    },
  };
};

const addOrUpdateGoalItemHandler = (
  state: RootState,
  action: PayloadAction<MentoringProgramGoalResponse>,
) => {
  const { enrollmentId, goalItem } = action.payload;
  if (!state.models.mentorshipProgramGoalItems[enrollmentId].goals[goalItem.id]) {
    state.models.mentorshipProgramGoalItems[enrollmentId].totalCount += 1;
  }
  state.models.mentorshipProgramGoalItems[enrollmentId].goals[goalItem.id] = goalItem;
};

const removeDeletedGoalItemHandler = (
  state: RootState,
  action: ReturnType<typeof deleteMentorshipProgramGoalItem.fulfilled>,
) => {
  const {
    meta: {
      arg: { enrollmentId, id: goalId },
    },
  } = action;
  delete state.models.mentorshipProgramGoalItems[enrollmentId].goals[goalId];
  state.models.mentorshipProgramGoalItems[enrollmentId].totalCount -= 1;
};

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(
      getMentorshipProgramGoalItems.fulfilled,
      setProgramGoalItemActionHandler,
    )
    .addCase(
      createMentorshipProgramGoalItem.fulfilled,
      addOrUpdateGoalItemHandler,
    )
    .addCase(
      updateMentorshipProgramGoalItem.fulfilled,
      addOrUpdateGoalItemHandler,
    )
    .addCase(
      deleteMentorshipProgramGoalItem.fulfilled,
      removeDeletedGoalItemHandler,
    )
    .addCase(
      setMentorshipProgramGoalsTotalCount,
      (state: RootState, action: PayloadAction<{ enrollmentId: number, totalCount: number }>) => {
        const { enrollmentId, totalCount } = action.payload;
        state.models.mentorshipProgramGoalItems[enrollmentId] = {
          ...state.models.mentorshipProgramGoalItems[enrollmentId],
          totalCount,
        };
      },
    );
});
